import Box from "@/components/Box";
import { EVENT_CONNECTIONS_QUERY } from "@/graphql/knowledgeCenter/webinars";
import Stack from "@/tpo/Stack";
import { useQuery } from "@apollo/client";

import DashboardCarousel, { DashboardCarouselPanel } from "./DashboardCarousel";
import EventDashboardCarouselCard from "./EventDashboardCarouselCard";
import {
  dashboardEventsMaxItems,
  dashboardInnerStackGap,
  dashboardSectionTitle,
  learningHubDashboardCarouselInset,
  lhDashboardBp
} from "./dashboardLayout";

export default function UpcomingEventsSection() {
  const { data, loading } = useQuery(EVENT_CONNECTIONS_QUERY, {
    variables: {
      first: dashboardEventsMaxItems,
      orderBy: "-start_time",
      types: []
    }
  });

  const now = Date.now();
  const events =
    data?.eventConnections?.edges
      ?.map(edge => edge.node)
      ?.filter(event => new Date(event.endTime).getTime() >= now)
      ?.sort((a, b) => new Date(a.startTime).getTime() - new Date(b.startTime).getTime())
      ?.slice(0, dashboardEventsMaxItems) ?? [];

  if (loading || !events.length) {
    return null;
  }

  return (
    <Stack
      gap={dashboardInnerStackGap}
      bg="#DCD2F8"
      borderRadius={20}
      width="100%"
      minWidth={0}
      pt={lhDashboardBp(40, 48, 60)}
      pb={lhDashboardBp(60, 68, 80)}
    >
      <DashboardCarousel
        flickingInset={learningHubDashboardCarouselInset}
        title={
          <Box {...dashboardSectionTitle} textAlign="center" px={learningHubDashboardCarouselInset}>
            Upcoming events
          </Box>
        }
      >
        {events.map(event => (
          <DashboardCarouselPanel key={event.id}>
            <EventDashboardCarouselCard {...event} />
          </DashboardCarouselPanel>
        ))}
      </DashboardCarousel>
    </Stack>
  );
}
